import script from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"
export * from "./TermsOfService.vue?vue&type=script&setup=true&lang=js"

import "./TermsOfService.vue?vue&type=style&index=0&id=66959bca&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66959bca"]])

export default __exports__